export default __webpack_public_path__ + "static/media/36I-102628_-15538_0.e2cfaa4f.jpg";